<template>
  <div class="footer-text">
    <div class="footer-text__section">
      <p class="footer-text__ttl">Права на контент © {{ currentYear }}</p>
      <p class="footer-text__txt">Все материалы Drops Capital защищены законом. Любое использование или копирование возможно только с нашего письменного согласия.</p>
    </div>
    <div class="footer-text__section">
      <p class="footer-text__ttl">Отказ от ответственности</p>
      <p class="footer-text__txt">Вся информация на сайте предназначена только для ознакомления. Мы не даем инвестиционных консультаций и не являемся инвестиционным советником.</p>
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  //Получаем текущий год
  const currentYear = computed(()=> new Date().getFullYear());
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>